module.exports = __webpack_public_path__ + "media/images/category_icons/category_icon_2-7a4920293b0f330fa2635ddc69193533.svg";